import React from "react";
import { Btn } from "./utils";
import Overlay from "../components/overlay/Overlay";

const DeletePopup = ({ isDelete, setIsDelete, text, delFunc, loading }) => {
  return (
    <div>
      {isDelete && <Overlay />}
      <div
        className="del_est"
        style={isDelete ? { display: "flex", width: 'fit-content' } : { display: "none" }}
      >
        <h3>Delete Property</h3>
        <p>Are you sure you want to delete {text}. This action cannot be undone.</p>
        <div className="delete_btn">
          <Btn
            btnText={"Cancel"}
            btnClass={"btn_cancel"}
            btnClick={() => {setIsDelete(false)}}
          />
          <Btn btnText={"Delete"} btnClass={"btn_del"} btnClick={delFunc} loading={loading} />
        </div>
      </div>
    </div>
  );
};

export default DeletePopup;
